import { autoCapitalize } from '@/utils/autoCapitalize'
import { ClinicListData } from './ClinicListMapper.types'

class ClinicListMapper {
  toDomain(persistenceClinicData: ClinicListData) {
    return {
      id: persistenceClinicData?.id,
      name: autoCapitalize(persistenceClinicData?.nome),
      product: persistenceClinicData?.produto,
      flags: {
        hasDisabledAgreement:
          persistenceClinicData?.flagPossuiConvenioDesabilitado,
        hasMultipleAgreement:
          persistenceClinicData?.flagHabilitarMultiplosCartoesConvenio,
      },
    }
  }
}

export default new ClinicListMapper()
